import { render, staticRenderFns } from "./xboot-library.vue?vue&type=template&id=87ec19fe&"
import script from "./xboot-library.vue?vue&type=script&lang=js&"
export * from "./xboot-library.vue?vue&type=script&lang=js&"
import style0 from "./xboot-library.vue?vue&type=style&index=0&id=87ec19fe&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports